import { Link } from 'react-router-dom';

export default function About() {
  return (
    <section className="py-20 bg-white">
      <div className="w-full px-4 sm:px-8 lg:px-20">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          {/* Left: Image */}
          <div className="relative">
            <div className="relative rounded-2xl overflow-hidden shadow-2xl">
              <img
                src="https://public.readdy.ai/ai/img_res/edited_30408776e1bee4cdc59d6251d9a75c30_7310c090.jpg"
                alt="LumanyiTech Team"
                className="w-full h-[400px] lg:h-[500px] object-cover object-top"
              />
            </div>
            {/* Floating Badge */}
            <div className="absolute -bottom-6 -right-6 bg-[#3782df] text-white p-6 rounded-xl shadow-xl">
              <div className="text-3xl font-bold mb-1">20+</div>
              <div className="text-sm opacity-90">Projects Delivered</div>
            </div>
          </div>

          {/* Right: Content */}
          <div>
            <div className="inline-flex items-center gap-2 px-4 py-2 bg-[#3782df]/10 rounded-full mb-6">
              <div className="w-2 h-2 bg-[#3782df] rounded-full"></div>
              <span className="text-[#3782df] text-sm font-medium">About LumanyiTech</span>
            </div>

            <h2 className="text-3xl sm:text-4xl font-bold text-gray-900 mb-6">
              Building Digital Solutions That Drive Real Growth
            </h2>

            <p className="text-base text-gray-600 mb-6 leading-relaxed">
              LumanyiTech is a full-service technology and business solutions provider. We combine technical expertise with strategic insight to help businesses modernize, scale, and compete in today's digital economy.
            </p>

            <p className="text-base text-gray-600 mb-8 leading-relaxed">
              From custom web development and data analytics to agribusiness transformation and financial compliance — we deliver tailored solutions that align with your goals and drive measurable results.
            </p>

            {/* Features */}
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-8">
              <div className="flex items-start gap-3">
                <div className="w-6 h-6 flex items-center justify-center flex-shrink-0">
                  <i className="ri-check-line text-xl text-[#3782df]"></i>
                </div>
                <div>
                  <div className="font-semibold text-gray-900 text-sm mb-1">End-to-End Support</div>
                  <div className="text-sm text-gray-600">From strategy to execution</div>
                </div>
              </div>
              <div className="flex items-start gap-3">
                <div className="w-6 h-6 flex items-center justify-center flex-shrink-0">
                  <i className="ri-check-line text-xl text-[#3782df]"></i>
                </div>
                <div>
                  <div className="font-semibold text-gray-900 text-sm mb-1">Industry Expertise</div>
                  <div className="text-sm text-gray-600">Proven across sectors</div>
                </div>
              </div>
              <div className="flex items-start gap-3">
                <div className="w-6 h-6 flex items-center justify-center flex-shrink-0">
                  <i className="ri-check-line text-xl text-[#3782df]"></i>
                </div>
                <div>
                  <div className="font-semibold text-gray-900 text-sm mb-1">Client-Centric</div>
                  <div className="text-sm text-gray-600">Your success is our priority</div>
                </div>
              </div>
              <div className="flex items-start gap-3">
                <div className="w-6 h-6 flex items-center justify-center flex-shrink-0">
                  <i className="ri-check-line text-xl text-[#3782df]"></i>
                </div>
                <div>
                  <div className="font-semibold text-gray-900 text-sm mb-1">Innovation-Driven</div>
                  <div className="text-sm text-gray-600">Latest tools & methods</div>
                </div>
              </div>
            </div>

            <Link 
              to="/about" 
              className="inline-flex items-center gap-2 px-6 py-3 bg-[#3782df] text-white text-sm font-medium rounded-lg hover:bg-[#2968c4] transition-colors whitespace-nowrap"
            >
              Learn More About Us
              <i className="ri-arrow-right-line"></i>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}